<template>
  <div class="order-account-edit">
    <QS-scroller-box>
      <QS-h4-title title="退车状态" />
      <form-text-box
        :column="3"
        :dataList="orderInfoConfig.list"
        :model="orderInfoConfig.model"
      />

      <QS-h4-title title="违章/事故/维保信息" />
      <form-text-box
        :column="3"
        :dataList="mergeInfoConfig.list"
        :model="mergeInfoConfig.model"
      />

      <QS-h4-title title="费用核算" />

      <el-alert
        title="请认真核对参与结算的付款项和收款项，及相应的金额。确认后将对应生成相应的收款单或付款单。如已配置开启审批，则在审批通过后可结算认款。"
        type="info"
        :show-icon="false"
        :closable="false"
      >
      </el-alert>

      <el-alert
        class="mt24"
        title="① 确认参与结算的付款项"
        type="info"
        :show-icon="false"
        :closable="false"
      >
        <template slot="title">
          ① 确认参与结算的付款项
        </template>
        <template slot="close">
          剩余应付总金额：{{ paymentSurplusAmount }}元
        </template>
      </el-alert>

      <QS-common-table
        :data="paymentList"
        :columns="paymentColumns"
        emptyText="暂无付款项"
        :pagination="false"
      >
      </QS-common-table>

      <el-alert
        class="mt24"
        title="② 确认参与结算的收款项"
        type="info"
        :show-icon="false"
        :closable="false"
      >
        <template slot="title">
          ② 确认参与结算的收款项
        </template>
        <template slot="close">
          剩余应收总金额：{{ receivableSurplusAmount }}元
        </template>
      </el-alert>

      <QS-common-table
        ref="receivableTable"
        :data="receivableList"
        :columns="receivableColumns"
        :row-class-name="tableRowClassName"
        emptyText="暂无收款项"
        :pagination="false"
      />

      <div class="receivable-add mt24">
        <el-select
          v-model="receivableCustomFeeType"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in receivableCustomFeeList"
            :key="item.feeType"
            :label="item.feeName"
            :value="item.feeType"
          ></el-option>
        </el-select>
        <el-button
          type="primary"
          :disabled="!receivableCustomFeeType"
          @click="handleReceivableAdd(receivableCustomFeeType)"
          >新增收款项</el-button
        >
      </div>

      <template slot="bottomAction">
        <div class="btn-group">
          <el-button @click="handleCancel">取消</el-button>
          <el-button type="primary" @click="handleSave" v-if="!previewBtnDisabled">保存</el-button>
          <el-button type="primary" @click="handlePreview" :disabled="previewBtnDisabled">{{ previewBtnText }}</el-button>
        </div>
      </template>

      <!-- 车辆交接完成时间编辑弹窗 -->
      <PreviewSettlementDialog
        ref="previewSettlementDialog"
        :orderId="orderId"
        :dailyRule="orderInfo.dailyRule"
        :bizType="orderInfo.bizType"
        :takeOverTime="orderInfo.carTakeOverTime"
        :disabledDate="orderInfo.outStockTime"
        @takeRuleChange="handleTakeOverTimeChange"
      />

      <!-- 收款项编辑弹窗 -->
      <el-dialog
        :title="editModal.title"
        :visible.sync="editModal.show"
        width="80%"
        @closed="handleReceivableEditCancel"
      >
        <div class="edit-modal-body">
          <div class="edit-modal-header">
            <el-button
              type="minor"
              icon="el-icon-plus"
              :disabled="!!editModal.itemDetail"
              @click="handleReceivableItemDetailAdd"
              >新增应收</el-button
            >
            <div class="edit-modal-tips">
              <i class="el-icon-info"></i>
              <span
                >核算中新增的应收项目，在提交核算前可编辑，在订单核算完成提交后将自动生成应收单。</span
              >
            </div>
          </div>
          <div
            class="edit-modal-itemDetailTable mt12"
            v-if="editModal.itemDetail"
          >
            <QS-common-table
              :data="editModal.itemDetail ? [editModal.itemDetail] : []"
              :columns="receivableItemDetailColumns"
              :pagination="false"
            >
            </QS-common-table>
          </div>
          <div class="edit-modal-receivableItemTable mt12">
            <el-alert title="历史应收" :show-icon="false" :closable="false">
              <template slot="title">
                <span class="edit-modal-receivableItemTable-title"
                  >历史应收</span
                >
              </template>
              <template slot="close">
                <span class="edit-modal-surplusAmount"
                  >剩余应收金额：{{ editModalSurplusAmount }}元</span
                >
              </template>
            </el-alert>

            <QS-common-table
              :data="editModal.receivableItemList"
              :columns="receivableHistoryItemColumns"
              emptyText="暂无应收数据"
              :loading="tableLoading"
              :pagination="editModal.pagination"
              @change="handlePaginationChange"
            >
            </QS-common-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleReceivableEditCancel">取 消</el-button>
          <el-button type="primary" @click="handleReceivableEditConfirm"
            >确 定</el-button
          >
        </span>
      </el-dialog>

      <!-- 预览核算结果弹窗 -->
      <el-dialog
        :title="previewModal.title"
        :visible.sync="previewModal.show"
        width="80%"
        @closed="handlePreviewCancel"
      >
        <div class="preview-modal-body">
          <div class="preview-modal-header">
            <el-alert
              title="以下信息请认真核对，提交后会生成对应的收付款单据（如开启了审批则在审批通过后生成），信息将无法修改。"
              type="info"
              :closable="false"
            >
            </el-alert>
          </div>
          <form-text-box
            class="mt12"
            :column="3"
            :dataList="previewResultInfoConfig.list"
            :model="previewResultInfoConfig.model"
          />
          <div class="preview-modal-table">
            <QS-common-table
              v-if="previewModal.resultType"
              :data="previewModal.resultItemList"
              :columns="previewResultColumns"
              emptyText="暂无收付款项"
              :pagination="false"
            >
            </QS-common-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handlePreviewCancel">取 消</el-button>
          <el-button type="primary" @click="handleSubmit">提 交</el-button>
        </span>
      </el-dialog>
    </QS-scroller-box>
  </div>
</template>

<script>
import moment from 'moment'
import PreviewSettlementDialog from '@/bizComponents/PreviewSettlementDialog/index.vue'
import { getEnum, getSubmitDingTalkShow } from '@/api/global'
import {
  getOrderAccount,
  previewOrderAccount,
  saveOrderAccountSignCheck,
  submitOrderAccountSignCheck,
} from '@/api/domain/orders'
import { getReceivableList, getReceivableStatistic } from '@/api/domain/finance'
import { limitMoreZero } from '@/utils/validate'
import { convertNumber } from '@/utils/'
import selectOption from '@/store/dict/selectOptionDict'
import Sortable from 'sortablejs'
import { operateMaxShowLength } from '@/store/dict/config'

const REQUEST_TIMEOUT = 15000

function withRequestTimeout(promise, timeout = REQUEST_TIMEOUT) {
  let timer
  const timeoutPromise = new Promise((_, reject) => {
    timer = setTimeout(() => reject(new Error('request timeout')), timeout)
  })
  return Promise.race([promise, timeoutPromise]).finally(() => {
    clearTimeout(timer)
  })
}

// 收款项编辑弹窗默认配置
const EDIT_MODAL_DEFAULT = {
  show: false,
  title: '',
  feeType: '',
  feeName: '',
  itemDetail: null,
  surplusAmount: '',
  receivableAmount: '',
  receivableItemList: [],
  pagination: {
    pageNum: 1,
    pageSize: 10,
    total: 0,
    pageSizes: [5, 10, 20, 50],
  },
}

// 核算预览弹窗默认配置
const PREVIEW_MODAL_DEFAULT = {
  show: false,
  title: '',
  plateNo: '',
  returnCarType: '',
  carTakeOverTime: '',
  resultAmount: '',
  resultType: '',
  resultItemList: [],
}

export default {
  components: {
    PreviewSettlementDialog,
  },
  props: {
    orderId: {
      type: [Number, String],
    },
    orderAccountDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 订单信息
      orderInfo: {
        plateNo: '', // 车牌号
        customerName: '', // 客户姓名
        orderState: '', // 订单状态
        returnCarType: '', // 退车类型
        returnCarReason: '', // 退车原因
        inventoryState: '', // 库存状态
        outStockTime: '', // 车辆计租开始日
        carTakeOverTime: '', // 车辆交接完成时间
        bizType: 10, // 订单业务类型 10:个人订单 20:企业子订单
        dailyRule: 0, // 日租金计算规则
      },
      // 违章/维保/事故信息
      mergeInfo: {
        violationCount: 0, // 违章数量
        violationHandledCount: 0, // 违章已处理数量
        maintainCount: 0, // 维保数量
        maintainedCount: 0, // 维保已处理数量
        accidentCount: 0, // 事故数量
        accidentHandledCount: 0, // 事故已处理数量
      },
      paymentList: [], // 付款项列表
      receivableList: [], // 收款项列表
      paymentColumns: [
        // 付款项列表配置
        {
          name: 'feeName',
          columnProps: {
            label: '付款项',
            prop: 'feeName',
            width: 100,
          },
        },
        {
          name: 'payAmount',
          columnProps: {
            label: '应付金额',
            prop: 'payAmount',
          },
          columnHeaderTooltip:
            '对应付款项下，所有已完成+未完成（不包含已关闭）的应付单的应付金额总和',
          render: ({ row }) => {
            if (row.feeName === '运营流水') {
              return this.$createElement(
                'el-input',
                {
                  slot: 'append',
                  attrs: {
                    value: row.payAmount,
                    placeholder: '请输入',
                  },
                  on: {
                    input: (newValue) => {
                      limitMoreZero(
                        newValue,
                        (e) => {
                          row.payAmount = e
                        },
                        5,
                      )
                    },
                    change: () => {
                      this.handleCalculatePaymentItemSurplusAmount(row)
                    },
                  },
                },
                [
                  this.$createElement(
                    'span',
                    {
                      slot: 'append',
                    },
                    '元',
                  ),
                ],
              )
            }
            return `${convertNumber(row.payAmount)}元`
          },
        },
        {
          name: 'paidAmount',
          columnProps: {
            label: '已付金额',
            prop: 'paidAmount',
          },
          columnHeaderTooltip:
            '对应付款项下，所有已完成+未完成（不包含已关闭）的应付单的已付金额总和',
          render: ({ row }) => {
            if (row.feeName === '运营流水') {
              return this.$createElement(
                'div',
                {
                  style: {
                    marginTop:
                      Number(row.paidAmount) > Number(row.payAmount)
                        ? '34px'
                        : '0',
                  },
                },
                [
                  this.$createElement(
                    'el-input',
                    {
                      slot: 'append',
                      attrs: {
                        value: row.paidAmount,
                        placeholder: '请输入',
                      },
                      on: {
                        input: (newValue) => {
                          limitMoreZero(
                            newValue,
                            (e) => {
                              if (Number(e) > Number(row.payAmount)) {
                                this.hasError = true
                              } else {
                                this.hasError = false
                              }
                              row.paidAmount = e
                            },
                            5,
                          )
                        },
                        change: () => {
                          this.handleCalculatePaymentItemSurplusAmount(row)
                        },
                      },
                    },
                    [
                      this.$createElement(
                        'span',
                        {
                          slot: 'append',
                        },
                        '元',
                      ),
                    ],
                  ),
                  Number(row.paidAmount) > Number(row.payAmount)
                    ? this.$createElement(
                      'p',
                      {
                        style: {
                          margin: '2px 0 0 0',
                          height: '32px',
                          lineHeight: '16px',
                          fontSize: '12px',
                          color: 'red',
                        },
                      },
                      '填写已付金额有误，不可高于应付金额',
                    )
                    : '',
                ],
              )
            }
            return `${convertNumber(row.paidAmount)}元`
          },
        },
        {
          name: 'payingAmount',
          columnProps: {
            label: '付款中金额',
            prop: 'payingAmount',
          },
          columnHeaderTooltip:
            '对应付款项下，所有已完成+未完成（不包含已关闭）的应付单的付款中金额总和。付款中的状态是指有正在进行中（在审批中）的付款单。',
          render: ({ row }) => {
            return `${convertNumber(row.payingAmount)}元`
          },
        },
        {
          name: 'surplusAmount',
          columnProps: {
            label: '剩余应付金额',
            prop: 'surplusAmount',
          },
          columnHeaderTooltip: '应付金额-已付金额-付款中金额',
          render: ({ row }) => {
            return `${convertNumber(row.surplusAmount)}元`
          },
        },
        {
          name: 'remarks',
          columnProps: {
            label: '备注',
            prop: 'remarks',
          },
          render: ({ row }) => {
            if (!['押金退款', '租金退款', '运营流水'].includes(row.feeName)) {
              return '--'
            }
            return this.$createElement('el-input', {
              props: {
                value: row.remarks,
              },
              attrs: {
                placeholder: '请输入备注',
              },
              on: {
                input: (newValue) => {
                  row.remarks = newValue
                },
              },
            })
          },
        },
        {
          name: 'photo',
          columnProps: {
            label: '备注图片',
            prop: 'photo',
            width: 200,
          },
          render: ({ row }) => {
            if (!['押金退款', '租金退款', '运营流水'].includes(row.feeName)) {
              return '--'
            }
            return this.$createElement('UploadCommon', {
              style: {
                marginTop: '18px',
              },
              props: {
                fileList: row.photos,
                isAlone: false,
                limit: 3,
                showUploadBtnByLimit: 3,
                sizeType: 4,
                isShowTitle: false,
                commonUpload: true,
                group: 'order',
                code: 'order_cost_account_note_pic',
              },
            })
          },
        },
        {
          name: 'openDeduct',
          columnProps: {
            label: '参与抵扣结算',
            prop: 'openDeduct',
            width: 150,
          },
          render: ({ row }) => {
            if (!['押金退款', '租金退款', '运营流水', '司机收入'].includes(row.feeName)) {
              return '开启'
            }
            const defaultColor = '#323233'
            const highlightColor = '#2E7EFF'
            return this.$createElement('div', {}, [
              this.$createElement(
                'span',
                {
                  style: {
                    color: row.openDeduct ? defaultColor : highlightColor,
                  },
                },
                '关闭',
              ),
              this.$createElement('el-switch', {
                style: {
                  margin: '0 4px',
                },
                props: {
                  value: row.openDeduct,
                  'active-value': 1,
                  'inactive-value': 0,
                },
                on: {
                  change(newValue) {
                    row.openDeduct = newValue
                  },
                },
              }),
              this.$createElement(
                'span',
                {
                  style: {
                    color: row.openDeduct ? highlightColor : defaultColor,
                  },
                },
                '开启',
              ),
            ])
          },
        },
      ],
      receivableColumns: [
        // 收款项列表配置
        {
          name: 'feeName',
          columnProps: {
            label: '收款项',
            prop: 'feeName',
          },
        },
        {
          name: 'receivableAmount',
          columnProps: {
            label: '应收金额',
            prop: 'receivableAmount',
          },
          columnHeaderTooltip:
            '对应收款项下，所有已完成+未完成（不包含已关闭）的应收单的应收金额总和',
          render: ({ row }) => {
            if (!row.feeState) {
              return '暂无应收单，可点击新增后进行收款'
            }
            return `${convertNumber(row.receivableAmount)}元`
          },
        },
        {
          name: 'receivedAmount',
          columnProps: {
            label: '已收金额',
            prop: 'receivedAmount',
          },
          columnHeaderTooltip:
            '对应收款项下，所有已完成+未完成（不包含已关闭）的应收单的已收金额总和',
          render: ({ row }) => {
            if (!row.feeState) return
            return `${convertNumber(row.receivedAmount)}元`
          },
        },
        {
          name: 'receivingAmount',
          columnProps: {
            label: '收款中金额',
            prop: 'receivingAmount',
          },
          columnHeaderTooltip:
            '对应收款项下，所有已完成+未完成（不包含已关闭）的应收单的收款中金额总和。收款中的状态是指有正在进行中（在审批中）的收款单。',
          render: ({ row }) => {
            if (!row.feeState) return
            return `${convertNumber(row.receivingAmount)}元`
          },
        },
        {
          name: 'surplusAmount',
          columnProps: {
            label: '剩余应收金额',
            prop: 'surplusAmount',
          },
          columnHeaderTooltip: '应收金额-已收金额-收款中金额',
          render: ({ row }) => {
            if (!row.feeState) return
            return `${convertNumber(row.surplusAmount)}元`
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
          },
          maxShowLength: operateMaxShowLength,
          render: ({ row, $index }) => {
            if (row?.feeName === '租金' || row?.feeName === '流水代收') {
              return '--'
            }

            return this.buildButtonList(row, $index)
          },
        },
      ],
      receivableItemDetailColumns: [
        // 收款项新增应收的列表配置
        {
          name: 'feeName',
          columnProps: {
            label: '新增收款项',
            prop: 'feeName',
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            label: '车牌号',
            prop: 'plateNo',
            width: 110,
          },
        },
        {
          name: 'customerName',
          columnProps: {
            label: '付款方',
            prop: 'customerName',
            width: 160,
          },
        },
        {
          name: 'receivableDate',
          columnProps: {
            label: '应收日期',
            prop: 'receivableDate',
          },
        },
        {
          name: 'receivableAmount',
          columnProps: {
            label: '收款金额',
            prop: 'receivableAmount',
          },
          render: ({ row }) => {
            return this.$createElement(
              'el-input',
              {
                slot: 'append',
                attrs: {
                  value: row.receivableAmount,
                  placeholder: '请输入',
                },
                on: {
                  input: (newValue) => {
                    limitMoreZero(
                      newValue,
                      (e) => {
                        row.receivableAmount = e
                      },
                      20,
                    )
                  },
                },
                directives: [
                  {
                    name: 'number',
                    arg: 'money',
                    value: {
                      isHideErr: true,
                    },
                  },
                ],
              },
              [
                this.$createElement(
                  'span',
                  {
                    slot: 'append',
                  },
                  '元',
                ),
              ],
            )
          },
        },
        {
          name: 'remarks',
          columnProps: {
            label: '备注',
            prop: 'remarks',
          },
          render: ({ row }) => {
            return this.$createElement('el-input', {
              props: {
                value: row.remarks,
              },
              attrs: {
                placeholder: '请输入备注',
              },
              on: {
                input: (newValue) => {
                  row.remarks = newValue
                },
              },
            })
          },
        },
        {
          name: 'photo',
          columnProps: {
            label: '备注图片',
            prop: 'photo',
            width: 300,
          },
          render: ({ row }) => {
            return this.$createElement('UploadCommon', {
              style: {
                marginTop: '18px',
              },
              props: {
                fileList: row.photos,
                isAlone: false,
                limit: 3,
                showUploadBtnByLimit: 3,
                sizeType: 4,
                isShowTitle: false,
                commonUpload: true,
                group: 'order',
                code: 'order_cost_account_note_pic',
              },
            })
          },
        },
      ],
      receivableHistoryItemColumns: [
        // 收款项历史应收的列表配置
        {
          name: 'id',
          columnProps: {
            label: '应收ID',
            prop: 'id',
          },
          render: ({ row }) => {
            return this.$createElement(
              'a',
              {
                attrs: {
                  href: `/finance/collection/detail?id=${row.id}`,
                  target: '__blank',
                },
              },
              row.id,
            )
          },
        },
        {
          name: 'receivableDate',
          columnProps: {
            label: '应收日期',
            prop: 'receivableDate',
          },
        },
        {
          name: 'receivableAmount',
          columnProps: {
            label: '应收金额',
            prop: 'receivableAmount',
          },
          columnHeaderTooltip: '应收单下的总应收金额',
          render: ({ row }) => `${convertNumber(row.receivableAmount)}元`,
        },
        {
          name: 'receivedAmount',
          columnProps: {
            label: '已收金额',
            prop: 'receivedAmount',
          },
          columnHeaderTooltip: '应收单下已认款的实收金额',
          render: ({ row }) => `${convertNumber(row.receivedAmount)}元`,
        },
        {
          name: 'receivingAmount',
          columnProps: {
            label: '收款中金额',
            prop: 'receivingAmount',
          },
          columnHeaderTooltip: '有正在进行中（在审批中）的收款金额',
          render: ({ row }) => `${convertNumber(row.receivingAmount)}元`,
        },
        {
          name: 'remainAmount',
          columnProps: {
            label: '剩余应收金额',
            prop: 'remainAmount',
          },
          columnHeaderTooltip: '应收金额-已收金额-收款中金额',
          render: ({ row }) => `${convertNumber(row.remainAmount)}元`,
        },
        {
          name: 'receivableState',
          columnProps: {
            label: '收款状态',
            prop: 'receivableState',
          },
          columnHeaderTooltip:
            '应收单的收款状态：已完成表示应收金额已全部实收，未完成表示有剩余应收',
          render: ({ row }) => selectOption.batchStateDict[row.receivableState],
        },
      ],
      receivableCustomFeeType: '', // 可新增的收款项类型（当前选中的）
      receivableCustomFeeList: [], // 可新增的收款项列表
      editModal: JSON.parse(JSON.stringify(EDIT_MODAL_DEFAULT)), // 收款项编辑弹窗
      previewModal: JSON.parse(JSON.stringify(PREVIEW_MODAL_DEFAULT)), // 预览核算结果弹窗
      orderAccountBizType: 17, // 订单核算的审批流类型
      needDingTalkApprove: false, // 是否需要钉钉审批
      pageLoading: false,
      tableLoading: false,
      hasError: false,
      // 预览核算结果信息展示配置
      previewResultInfoConfig: {
      // return {
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '车牌号',
              prop: 'plateNo',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '退车类型',
              prop: 'returnCarType',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车辆交接完成时间',
              prop: 'carTakeOverTime',
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '核算结果',
              prop: 'resultAmount',
            },
            render: (createElement) => {
              const _map = new Map([
                [
                  1,
                  `应向客户收款${convertNumber(
                    this.previewModal.resultAmount,
                  )}元`,
                ],
                [
                  2,
                  `应向客户退款${convertNumber(
                    this.previewModal.resultAmount,
                  )}元`,
                ],
              ])
              return createElement('div', [
                '核算结果：',
                createElement(
                  'span',
                  _map.get(this.previewModal.resultType) || '',
                ),
              ])
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '备注说明',
              prop: 'resultRemarks',
            },
            directives: [{ name: 'deleteEmoji' }],
            elConfig: {
              placeholder: '请输入',
              clearable: true,
              maxlength: 100,
            },
          },
          {
            el: 'upload',
            itemConfig: {
              label: '备注图片',
              prop: 'resultPhoto',
            },
            elConfig: {
              render: 'UploadCommon',
              listType: 'img',
              limit: 5,
              fileList: [],
              isAlone: false,
              multiple: true,
              commonUpload: true,
              group: 'order',
              code: 'order_preview_account_result_note_pic',
            },
          },
        ],
        model: {
          plateNo: '',
          returnCarType: '',
          carTakeOverTime: '',
          resultAmount: '',
          resultRemarks: '',
          resultPhoto: [],
        },
      // }
      },
    }
  },
  computed: {
    freeStateReceivableList() {
      return this.receivableList.filter((idt) => idt.feeState)
    },
    hasFirstRent() {
      if (
        !Array.isArray(this.receivableList) ||
        this.receivableList.length <= 0
      ) { return false }
      const item = this.receivableList.slice(0, 1)
      const hasFirstRent =
        item && item.length === 1 && item[0].feeName === '租金'
      return hasFirstRent
    },
    // 订单信息展示配置
    orderInfoConfig() {
      return {
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '订单状态:',
              prop: 'orderState',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '退车类型:',
              prop: 'returnCarType',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '退车原因:',
              prop: 'returnCarReason',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '库存状态:',
              prop: 'inventoryState',
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '车辆交接完成时间',
              prop: 'carTakeOverTime',
            },
            render: (createElement) => {
              return createElement(
                'el-form-item',
                {
                  props: {
                    label: '车辆交接完成时间:',
                    prop: 'carTakeOverTime',
                  },
                },
                this.orderInfo.carTakeOverTime
                  ? [
                    createElement('span', this.orderInfo.carTakeOverTime),
                    createElement(
                      'el-button',
                      {
                        style: {
                          marginLeft: '4px',
                        },
                        props: {
                          type: 'text',
                        },
                        nativeOn: {
                          click: (e) => {
                            e.stopPropagation()
                            this.handleTakeOverTimeEdit()
                          },
                        },
                      },
                      '编辑',
                    ),
                  ]
                  : '--',
              )
            },
          },
        ],
        model: {
          orderState: this.orderInfo.orderState,
          returnCarType: this.orderInfo.returnCarType,
          returnCarReason: this.orderInfo.returnCarReason,
          inventoryState: this.orderInfo.inventoryState,
          carTakeOverTime: this.orderInfo.carTakeOverTime,
        },
      }
    },
    // 违章/事故/维保信息展示配置
    mergeInfoConfig() {
      return {
        list: [
          {
            el: 'input',
            itemConfig: {
              label: '违章',
              prop: 'violationCount',
            },
            render: (createElement) => {
              return createElement(
                'el-form-item',
                {
                  props: {
                    label: '违章:',
                  },
                },
                [
                  createElement(
                    'el-button',
                    {
                      props: {
                        type: 'text',
                      },
                      nativeOn: {
                        click: (e) => {
                          e.stopPropagation()
                          this.toViolationRecord()
                        },
                      },
                    },
                    `数量${this.mergeInfo.violationCount}（已处理${
                      this.mergeInfo.violationHandledCount
                    }）`,
                  ),
                ],
              )
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '事故',
              prop: 'accidentCount',
            },
            render: (createElement) => {
              return createElement(
                'el-form-item',
                {
                  props: {
                    label: '事故:',
                  },
                },
                [
                  createElement(
                    'el-button',
                    {
                      props: {
                        type: 'text',
                      },
                      nativeOn: {
                        click: (e) => {
                          e.stopPropagation()
                          this.toAccidentList()
                        },
                      },
                    },
                    `数量${this.mergeInfo.accidentCount}（已处理${
                      this.mergeInfo.accidentHandledCount
                    }）`,
                  ),
                ],
              )
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '维保',
              prop: 'maintainCount',
            },
            render: (createElement) => {
              return createElement(
                'el-form-item',
                {
                  props: {
                    label: '维保:',
                  },
                },
                [
                  createElement(
                    'el-button',
                    {
                      props: {
                        type: 'text',
                      },
                      nativeOn: {
                        click: (e) => {
                          e.stopPropagation()
                          this.toMaintainList()
                        },
                      },
                    },
                    `数量${this.mergeInfo.maintainCount}（已处理${
                      this.mergeInfo.maintainedCount
                    }）`,
                  ),
                ],
              )
            },
          },
        ],
        model: {
          violationCount: this.mergeInfo.violationCount,
          violationHandledCount: this.mergeInfo.violationHandledCount,
          maintainCount: this.mergeInfo.maintainCount,
          maintainedCount: this.mergeInfo.maintainedCount,
          accidentCount: this.mergeInfo.accidentCount,
          accidentHandledCount: this.mergeInfo.accidentHandledCount,
        },
      }
    },

    // 剩余应付总金额
    paymentSurplusAmount() {
      return convertNumber(
        this.paymentList.reduce(
          (prev, current) => prev + (Number(current.surplusAmount) || 0),
          0,
        ),
      )
    },
    // 剩余应收总金额
    receivableSurplusAmount() {
      return convertNumber(
        this.receivableList.reduce(
          (prev, current) => prev + (Number(current.surplusAmount) || 0),
          0,
        ),
      )
    },
    // 剩余应收金额（编辑弹窗）
    editModalSurplusAmount() {
      return convertNumber(this.editModal.surplusAmount)
    },
    // 预览核算结果列表配置
    previewResultColumns() {
      const _map = new Map([
        [1, '收款项（向客户收款）'],
        [2, '付款项（向客户退款）'],
      ])

      const customerNameResultType = new Map([[1, '付款方'], [2, '收款方']])
      const accruedDateResultType = new Map([[1, '应收日期'], [2, '应付日期']])
      const accruedAmountResultType = new Map([
        [1, '应收金额'],
        [2, '应付金额'],
      ])
      return [
        {
          name: 'feeType',
          columnProps: {
            label: _map.get(this.previewModal.resultType) || '',
            prop: 'feeType',
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            label: '车牌号',
            prop: 'plateNo',
            width: 100,
          },
        },
        {
          name: 'customerName',
          columnProps: {
            label:
              customerNameResultType.get(this.previewModal.resultType) || '',
            prop: 'customerName',
          },
        },
        {
          name: 'accruedDate',
          columnProps: {
            label:
              accruedDateResultType.get(this.previewModal.resultType) || '',
            prop: 'accruedDate',
          },
        },
        {
          name: 'accruedAmount',
          columnProps: {
            label:
              accruedAmountResultType.get(this.previewModal.resultType) || '',
            prop: 'accruedAmount',
          },
          render: ({ row }) => `${convertNumber(row.accruedAmount)}元`,
        },
      ]
    },
    previewBtnDisabled() {
      return this.orderAccountDetail && this.orderAccountDetail.state === 5
    },
    previewBtnText() {
      return this.orderAccountDetail && this.orderAccountDetail.state === 5 ? '退款中' : '预览核算结果并提交'
    },
  },
  methods: {
    createButton(text, callback) {
      return this.$createElement(
        'el-button',
        {
          props: {
            type: 'text',
          },
          nativeOn: {
            click: callback,
          },
        },
        text,
      )
    },
    buildButtonList(row, rowIndex) {
      const arr = [
        this.createButton('编辑', () => this.handleReceivableEdit(row.feeType)),
      ]

      if (!row.feeState || row?.feeName === '租金') return arr
      if (
        (this.hasFirstRent && rowIndex !== 1) ||
        (!this.hasFirstRent && rowIndex !== 0)
      ) {
        arr.push(
          this.createButton('上移', () => this.handleSortUp(row, rowIndex)),
        )
      }

      if (rowIndex !== this.freeStateReceivableList.length - 1) {
        arr.push(
          this.createButton('下移', () => this.handleSortDown(row, rowIndex)),
        )
      }

      return arr
    },
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex === 0 && row?.feeName === '租金') || !row.feeState) {
        return 'ignore'
      }
      return ''
    },
    sortTable() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const _self = this
      const wrap = this.$refs.receivableTable.$el.querySelector(
        '.el-table__body-wrapper>table>tbody',
      )
      // 第二步，设置拖动项的拖动规则
      const rules = {
        filter: '.ignore',
        sort: true,
        animation: 500, // 拖动时的元素的位置变化的动画时长，
        onEnd(evt) {
          const { oldIndex, newIndex } = evt
          _self.receivableList.splice(
            newIndex,
            0,
            _self.receivableList.splice(oldIndex, 1)[0],
          )

          const _arr = _self.receivableList.slice(0)

          _self.receivableList = []
          _self.$nextTick(() => {
            _self.receivableList = [..._arr]
          })
        },
        onMove(evt) {
          return evt.related.className.indexOf('ignore') === -1
        },
      }
      // 第三步，初始化 --> 给拖动容器添加拖动规则
      Sortable.create(wrap, rules)
    },
    openPageLoading() {
      this.pageLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'QS-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)',
      })
    },
    closePageLoading() {
      if (this.pageLoading && this.pageLoading.close) {
        this.pageLoading.close()
      }
    },
    // 获取订单核算自定义费项列表
    async getOrderAccountCustomFeeList() {
      let res

      try {
        res = await await getEnum({
          type: 'orderAccountCustomFee', // 订单核算自定义费项
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1) {
        this.receivableCustomFeeList = (data || []).map((item) => ({
          feeType: item.code,
          feeName: item.name,
        }))
      }
    },
    // 获取是否需要钉钉审批
    async getSubmitDingTalkShow() {
      getSubmitDingTalkShow({
        bizType: this.orderAccountBizType,
      }).then(({ code, data }) => {
        if (code === 1) {
          this.needDingTalkApprove = data
        }
      })
    },
    // 获取订单核算详情
    async getOrderAccount() {
      let res

      this.openPageLoading()
      try {
        res = await withRequestTimeout(getOrderAccount({
          orderId: this.orderId,
        }))
      } catch (err) {
        console.error(err)
      } finally {
        this.closePageLoading()
      }

      if (!res) return

      const { code, data } = res

      if (code === 1) {
        const orderInfo = data.orderInfo || {}
        const mergeInfo = data.mergeInfo || {}

        this.orderInfo.plateNo = orderInfo.plateNo || ''
        this.orderInfo.customerName = orderInfo.customerName || ''
        this.orderInfo.orderState = orderInfo.orderState || ''
        this.orderInfo.returnCarType = orderInfo.returnCarType || ''
        this.orderInfo.returnCarReason = orderInfo.returnCarReason || ''
        this.orderInfo.inventoryState = orderInfo.inventoryState || ''
        this.orderInfo.outStockTime = orderInfo.outStockTime || ''
        this.orderInfo.carTakeOverTime = orderInfo.carTakeOverTime || ''
        this.orderInfo.bizType = orderInfo.bizType || ''

        this.mergeInfo.violationCount = mergeInfo.violationCount || 0
        this.mergeInfo.violationHandledCount =
          mergeInfo.violationHandledCount || 0
        this.mergeInfo.maintainCount = mergeInfo.maintainCount || 0
        this.mergeInfo.maintainedCount = mergeInfo.maintainedCount || 0
        this.mergeInfo.accidentCount = mergeInfo.accidentCount || 0
        this.mergeInfo.accidentHandledCount =
          mergeInfo.accidentHandledCount || 0

        this.paymentList = (data.paymentItemList || []).map((item) => {
          item.photos = this.getEchoUploadFileData(item.photo, true)
          return item
        })
        this.receivableList = (data.receivableItemList || []).map((item) => {
          item.photos = this.getEchoUploadFileData(item.photo, true)
          this.formateItemDetail(item)
          return item
        })
      }
    },
    // 更新租金/租金退款
    async update() {
      // 更新 新增应收款 应收时间 20231026
      if (this.receivableList) {
        const today = moment(new Date()).format('YYYY-MM-DD')
        const time = this.orderInfo.carTakeOverTime?.slice(0, 10) || today
        this.receivableList.forEach((item) => {
          if (item.itemDetail && item.itemDetail.receivableDate) {
            item.itemDetail.receivableDate = time
          }
        })
      }

      let res

      this.openPageLoading()
      try {
        res = await withRequestTimeout(getOrderAccount({
          orderId: this.orderId,
        }))
      } catch (err) {
        console.error(err)
      } finally {
        this.closePageLoading()
      }

      if (!res) return

      const { code, data } = res

      if (code === 1) {
        this.updateRentAmount(data.receivableItemList || [])
        this.updateRentAmountRefund(data.paymentItemList || [])
      }
    },
    // 更新租金和滞纳金的应收金额、已收金额、收款中金额、剩余应收金额
    updateRentAmount(receivableList) {
      // 租金
      const rentAmountItem = this.receivableList.find((item) => item.feeName === '租金')
      const rentAmountItemNew = receivableList.find((item) => item.feeName === '租金')
      if (rentAmountItem) {
        rentAmountItem.receivableAmount = rentAmountItemNew.receivableAmount
        rentAmountItem.receivedAmount = rentAmountItemNew.receivedAmount
        rentAmountItem.receivingAmount = rentAmountItemNew.receivingAmount
        rentAmountItem.surplusAmount = rentAmountItemNew.surplusAmount
      }
      // 滞纳金
      const overdueItem = this.receivableList.find((item) => item.feeName === '滞纳金')
      const overdueItemNew = receivableList.find((item) => item.feeName === '滞纳金')
      if (overdueItem) {
        overdueItem.receivableAmount = overdueItemNew.receivableAmount
        overdueItem.receivedAmount = overdueItemNew.receivedAmount
        overdueItem.receivingAmount = overdueItemNew.receivingAmount
        overdueItem.surplusAmount = overdueItemNew.surplusAmount
        // 如果编辑里有新增的应收项，新增项的收款金额也得加在里面
        // 由于前端可能有暂存没有提交到后端，所以此处需要结合前端暂存的数额和之前已经保存过得数额计算
        if (overdueItem.itemDetail) {
          overdueItem.receivableAmount = Number(overdueItem.receivableAmount) + Number(overdueItem.itemDetail.receivableAmount)
          overdueItem.surplusAmount = Number(overdueItem.surplusAmount) + Number(overdueItem.itemDetail.receivableAmount)
          if (overdueItemNew.itemDetail) {
            overdueItem.receivableAmount = Number(overdueItem.receivableAmount) - Number(overdueItemNew.itemDetail.receivableAmount)
            overdueItem.surplusAmount = Number(overdueItem.surplusAmount) - Number(overdueItemNew.itemDetail.receivableAmount)
          }
        }
      }
    },
    // 更新租金退款的应付金额、已付金额、付款中金额、剩余应付金额
    updateRentAmountRefund(paymentList) {
      const rentAmountRefundItem = this.paymentList.find(
        (item) => item.feeName === '租金退款',
      )
      const rentAmountRefundItemNew = paymentList.find(
        (item) => item.feeName === '租金退款',
      )
      if (rentAmountRefundItem) {
        rentAmountRefundItem.payAmount = rentAmountRefundItemNew.payAmount
        rentAmountRefundItem.paidAmount = rentAmountRefundItemNew.paidAmount
        rentAmountRefundItem.payingAmount = rentAmountRefundItemNew.payingAmount
        rentAmountRefundItem.surplusAmount =
          rentAmountRefundItemNew.surplusAmount
      }
    },
    // 获取某个收款项的剩余应收金额和应收金额
    async getReceivableSurplusAmount(feeType) {
      let res

      try {
        res = await getReceivableStatistic({
          sourceOrderId: this.orderId,
          sourceOrderType: this.orderInfo.bizType === 10 ? 2 : 6, // 2:个人订单 6:企业子订单
          content: feeType,
        })
      } catch (err) {
        this.$message.error('获取剩余应收金额失败')
      }
      const defaltData = { remainSum: 0, receivableSum: 0 }

      if (!res) return defaltData
      const { code, data } = res
      if (code === 1) {
        return {
          remainSum: data.remainSum || 0,
          receivableSum: data.receivableSum || 0,
        }
      }
      return defaltData
    },
    // 获取某个收款项的历史应收单
    async getReceivableList(feeType) {
      let res

      this.tableLoading = true
      try {
        res = await getReceivableList({
          sourceOrderId: this.orderId,
          sourceOrderType: this.orderInfo.bizType === 10 ? 2 : 6, // 2:个人订单 6:企业子订单
          content: feeType,
          pageSize: this.editModal.pagination.pageSize,
          pageNum: this.editModal.pagination.pageNum,
        })
      } catch (err) {
        this.$message.error('获取历史应收失败')
        console.error(err)
      } finally {
        this.tableLoading = false
      }

      if (!res) return []

      const { code, data } = res

      if (code === 1) {
        return data
      }
    },
    // 编辑车辆交接完成时间
    handleTakeOverTimeEdit() {
      this.$refs.previewSettlementDialog.open()
    },
    // 更新车辆交接完成时间
    handleTakeOverTimeChange({ newTakeOverTime }) {
      this.orderInfo.carTakeOverTime = newTakeOverTime
        ? moment(newTakeOverTime).format('YYYY-MM-DD HH:mm:ss')
        : ''
      this.update()
    },
    // 跳转违章记录列表
    toViolationRecord() {
      this.$router.push({
        path: '/vehicle/violation/record',
        query: {
          orderId: this.orderId,
        },
      })
    },
    // 跳转事故管理列表
    toAccidentList() {
      this.$router.push({
        path: '/vehicle/accident/list',
        query: {
          orderId: this.orderId,
        },
      })
    },
    // 跳转维保管理列表
    toMaintainList() {
      this.$router.push({
        path: '/vehicle/maintenance/list',
        query: {
          orderId: this.orderId,
        },
      })
    },
    async handlePaginationChange(payload) {
      const { pagination } = payload
      this.editModal.pagination.pageNum = pagination.pageNum
      this.editModal.pagination.pageSize = pagination.pageSize

      const { items: receivableItemList } = await this.getReceivableList(
        this.editModal.feeType,
      )
      this.editModal = {
        ...this.editModal,
        receivableItemList,
      }
    },
    // 运营流水的“应付金额”和“已付金额”变化时重新计算“剩余应付金额”
    handleCalculatePaymentItemSurplusAmount(fee) {
      fee.surplusAmount =
        (fee.payAmount || 0) - (fee.payingAmount || 0) - (fee.paidAmount || 0)
    },
    // 收款项新增应收后，更新收款项各金额
    handleUpdateReceivableItem(fee) {
      const { receivableAmount } = this.editModal
      // 历史应收累加金额
      const historyReceivableAmount = Number(receivableAmount)
      // 新增应收金额
      const addReceivableAmount = fee.itemDetail
        ? Number(fee.itemDetail.receivableAmount)
        : 0
      // 根据上面两个金额替换收款项的应收金额
      fee.receivableAmount =
        historyReceivableAmount + addReceivableAmount || '0.00'
      fee.receivedAmount = fee.receivedAmount || '0.00'
      fee.receivingAmount = fee.receivingAmount || '0.00'
      fee.surplusAmount =
        fee.receivableAmount - fee.receivedAmount - fee.receivingAmount
      fee.feeState = true
    },
    // 新增收款项
    handleReceivableAdd(feeType) {
      const feeName =
        (
          this.receivableCustomFeeList.find((item) => item.feeType === feeType) ||
          {}
        ).feeName || ''
      if (this.receivableList.some((item) => item.feeType === feeType)) {
        this.$message.error(`${feeName}已存在，请勿重复添加`)
        return
      }

      this.editModal = {
        show: true,
        title: `“${feeName}”款项应收明细`,
        feeType,
        feeName,
        itemDetail: null,
        surplusAmount: '0.00',
        receivableAmount: '0.00',
        receivableItemList: [],
        pagination: {
          ...this.editModal.pagination,
          total: 0,
        },
      }
    },
    // 上移动
    handleSortUp(row, index) {
      const tem = this.receivableList.slice(index - 1, index)
      this.receivableList.splice(index - 1, 1)
      this.receivableList.splice(index, 0, tem[0])
    },
    // 下移动
    handleSortDown(row, index) {
      const tem = this.receivableList.slice(index, index + 1)
      this.receivableList.splice(index, 1)
      this.receivableList.splice(index + 1, 0, tem[0])
    },
    // 编辑收款项
    async handleReceivableEdit(feeType) {
      this.openPageLoading()

      try {
        const { feeName, itemDetail } = this.receivableList.find(
          (item) => item.feeType === feeType,
        )
        const { remainSum: surplusAmount, receivableSum: receivableAmount } = await this.getReceivableSurplusAmount(feeType)
        const {
          items: receivableItemList,
          totalNum,
        } = await this.getReceivableList(feeType)

        const time = this.orderInfo.carTakeOverTime.slice(0, 10)
        if (
          time &&
          itemDetail &&
          itemDetail.receivableDate &&
          time !== itemDetail.receivableDate
        ) {
          itemDetail.receivableDate = time
        }

        this.editModal = {
          show: true,
          title: `“${feeName}”款项应收明细`,
          feeType,
          feeName,
          itemDetail: JSON.parse(JSON.stringify(itemDetail)),
          surplusAmount,
          receivableAmount,
          receivableItemList,
          pagination: {
            ...this.editModal.pagination,
            total: totalNum,
          },
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.closePageLoading()
      }
    },
    // 新增收款项应收
    handleReceivableItemDetailAdd() {
      // 不再是默认的时间  而是 车辆交接完成时间
      const today = moment(new Date()).format('YYYY-MM-DD')
      // 未履约的
      this.editModal.itemDetail = {
        feeType: this.editModal.feeType,
        feeName: this.editModal.feeName,
        plateNo: this.orderInfo.plateNo,
        customerName: this.orderInfo.customerName,
        receivableDate: this.orderInfo.carTakeOverTime.slice(0, 10) || today,
        receivableAmount: '0.00',
        remarks: '',
        photos: [],
      }
    },
    // 取消编辑收款项
    handleReceivableEditCancel() {
      this.resetEditModal()
    },
    // 确认编辑收款项
    handleReceivableEditConfirm() {
      const { feeType, feeName, itemDetail } = this.editModal
      const receivable = this.receivableList.find(
        (item) => item.feeType === feeType,
      )

      // 编辑
      if (receivable) {
        receivable.itemDetail = itemDetail || null
        this.handleUpdateReceivableItem(receivable)
      } else {
        // 新增
        const newReceivable = {
          feeType,
          feeName,
          receivableAmount: '0.00',
          receivedAmount: '0.00',
          receivingAmount: '0.00',
          surplusAmount: '0.00',
          feeState: Boolean(itemDetail),
          itemDetail: itemDetail || null,
        }
        this.receivableList.push(newReceivable)
        this.handleUpdateReceivableItem(newReceivable)
      }

      this.sortReceivableList()

      this.resetEditModal()
    },
    // 格式化收款项列表
    formateReceivableList(receivableList) {
      return receivableList.map((item, index) => {
        item.feeSort = index
        item.payAmount = Number(item.payAmount || 0).toFixed(2)
        item.paidAmount = Number(item.paidAmount || 0).toFixed(2)
        item.payingAmount = Number(item.payingAmount || 0).toFixed(2)
        item.surplusAmount = Number(item.surplusAmount || 0).toFixed(2)
        if (item.itemDetail) {
          item.itemDetail.receivableAmount = Number(
            item.itemDetail.receivableAmount || 0,
          ).toFixed(2)
          if (item.itemDetail.photos.length > 0) {
            item.itemDetail.photo = this.getUoloadCommonFileData(item.itemDetail.photos, true)
          } else {
            item.itemDetail.photo = JSON.stringify([])
          }
        }
        return item
      })
    },
    // 确认编辑收款项后重新排序（按按“剩余应收金额”降序排列）
    sortReceivableList() {
      const rentReceivableList = this.receivableList.filter(
        (item) => item.feeState,
      )
      const unrentReceivableList = this.receivableList.filter(
        (item) => !item.feeState,
      )
      this.receivableList = [...rentReceivableList, ...unrentReceivableList]
    },
    // 格式化付款项列表
    formatePaymentList(paymentList) {
      return paymentList.map((item, index) => {
        item.feeSort = index
        item.payAmount = Number(item.payAmount || 0).toFixed(2)
        item.paidAmount = Number(item.paidAmount || 0).toFixed(2)
        item.payingAmount = Number(item.payingAmount || 0).toFixed(2)
        item.surplusAmount = Number(item.surplusAmount || 0).toFixed(2)
        if (item.photos.length > 0) {
          item.photo = this.getUoloadCommonFileData(item.photos, true)
        } else {
          item.photo = null
        }
        return item
      })
    },
    // 格式化新增的应收单信息
    formateItemDetail(item) {
      if (item.itemDetail) {
        item.itemDetail = {
          ...item.itemDetail,
          photos: this.getEchoUploadFileData(item.itemDetail.photo, true),
        }
      } else {
        item.itemDetail = null
      }
    },
    // 预览核算结果
    async handlePreview() {
      if (this.hasError) {
        this.$message.error('填写已付金额有误，不可高于应付金额')
        return
      }
      this.openPageLoading()

      let res

      try {
        const params = {
          orderId: this.orderId,
          receivableItemParamList: this.formateReceivableList(
            this.receivableList,
          ),
          paymentItemParamList: this.formatePaymentList(this.paymentList),
        }

        // 先保存，以防数据丢失
        await saveOrderAccountSignCheck({
          ...params,
          carTakeOverTime: this.orderInfo.carTakeOverTime,
          approvalType: this.needDingTalkApprove ? 2 : '', // 2-提交钉钉审批
        })

        res = await previewOrderAccount({
          ...params,
        })
      } catch (err) {
        console.error(err)
      } finally {
        this.closePageLoading()
      }

      if (!res) return

      const { code, data } = res

      if (code === 1) {
        this.previewModal = {
          show: true,
          title: '请确认核算结果',
          plateNo: data.plateNo || '',
          returnCarType: data.returnCarType || '',
          carTakeOverTime: data.carTakeOverTime || '',
          resultAmount: data.resultAmount || '',
          resultType: data.resultType || '',
          resultItemList: data.accountResultDetail || [],
        }
        this.previewResultInfoConfig.model.plateNo = data.plateNo || ''
        this.previewResultInfoConfig.model.returnCarType = data.returnCarType || ''
        this.previewResultInfoConfig.model.carTakeOverTime = data.carTakeOverTime || ''
        this.previewResultInfoConfig.model.resultAmount = data.resultAmount || ''
        this.previewResultInfoConfig.model.resultPhoto = []
        this.previewResultInfoConfig.model.resultRemarks = ''
      }
    },
    // 取消预览核算
    handlePreviewCancel() {
      this.resetPreviewModal()
    },
    // 重置编辑弹窗
    resetEditModal() {
      this.editModal = JSON.parse(JSON.stringify(EDIT_MODAL_DEFAULT))
    },
    // 重置预览弹窗
    resetPreviewModal() {
      this.previewModal = JSON.parse(JSON.stringify(PREVIEW_MODAL_DEFAULT))
      this.previewResultInfoConfig.model.plateNo = ''
      this.previewResultInfoConfig.model.returnCarType = ''
      this.previewResultInfoConfig.model.carTakeOverTime = ''
      this.previewResultInfoConfig.model.resultAmount = ''
      this.previewResultInfoConfig.model.resultPhoto = []
      this.previewResultInfoConfig.model.resultRemarks = ''
    },
    // 取消
    handleCancel() {
      this.$emit('cancel')
    },
    // 保存
    async handleSave() {
      if (this.hasError) {
        this.$message.error('填写已付金额有误，不可高于应付金额')
        return
      }
      this.openPageLoading()

      let res

      try {
        res = await saveOrderAccountSignCheck({
          orderId: this.orderId,
          carTakeOverTime: this.orderInfo.carTakeOverTime,
          receivableItemParamList: this.formateReceivableList(
            this.receivableList,
          ),
          paymentItemParamList: this.formatePaymentList(this.paymentList),
          approvalType: this.needDingTalkApprove ? 2 : '', // 2-提交钉钉审批
        })
      } catch (err) {
        console.error(err)
      } finally {
        this.closePageLoading()
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.$message.success('保存成功')
        this.$emit('saveSuccess')
      } else {
        this.$message.error('保存失败')
        this.$emit('saveFailed')
      }
    },
    // 提交
    async handleSubmit() {
      if (this.hasError) {
        this.$message.error('填写已付金额有误，不可高于应付金额')
        return
      }

      const needDingTalkApproveMessage =
        '确认后将提交审批，无法再次修改金额，财务审批通过后才可进行费用结算'
      const noNeedDingTalkApproveMessage =
        '确认后将提交到财务核算，将无法再次修改金额'
      const message = this.needDingTalkApprove
        ? needDingTalkApproveMessage
        : noNeedDingTalkApproveMessage

      this.$confirm(message, '确认是否提交', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(async () => {
          this.openPageLoading()
          let res

          try {
            const resultPhotoEL = this.previewResultInfoConfig.list.find((item) => item.itemConfig.prop === 'resultPhoto')
            const resultPhoto = this.getUoloadCommonFileData(resultPhotoEL.elConfig.fileList, true)
            const { resultRemarks } = this.previewResultInfoConfig.model
            res = await submitOrderAccountSignCheck({
              orderId: this.orderId,
              carTakeOverTime: this.orderInfo.carTakeOverTime,
              receivableItemParamList: this.formateReceivableList(
                this.receivableList,
              ),
              paymentItemParamList: this.formatePaymentList(this.paymentList),
              approvalType: this.needDingTalkApprove ? 2 : '', // 2-提交钉钉审批
              resultRemarks,
              resultPhoto,
            })
          } catch (err) {
            console.error(err)
          } finally {
            this.closePageLoading()
          }

          if (!res) return

          const { code } = res

          if (code === 1) {
            this.$message.success('提交成功')
            this.resetPreviewModal()
            this.$emit('submitSuccess', {
              needDingTalkApprove: this.needDingTalkApprove,
            })
          } else {
            this.$emit('submitFailed', {
              errorCode: res.code,
            })
          }
        })
        .catch(() => null)
    },
  },
  async created() {
    await this.getOrderAccountCustomFeeList()
    this.getSubmitDingTalkShow()
    this.getOrderAccount()
  },
  mounted() {
    this.$nextTick(() => {
      this.sortTable()
    })
  },
}
</script>
<style lang="scss" scoped>
.basic-list {
  margin-top: 0;
}
.mt12 {
  margin-top: 12px;
}
.mt24 {
  margin-top: 24px;
}
.edit-modal-header {
  display: flex;
  align-items: center;
  .edit-modal-tips {
    margin-left: 16px;
  }
}
.edit-modal-receivableItemTable-title {
  position: relative;
  font-size: 15px;
  font-weight: bold;
  &::before {
    position: absolute;
    left: -8px;
    top: -6px;
    content: '';
    width: 3px;
    height: 30px;
    background: #2e7eff;
  }
}
.edit-modal-surplusAmount {
  font-size: 15px;
  font-weight: bold;
}
</style>
